import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder, imageResizer, activateSearchPage } from "../helpers"
import SubmitButton from "./elements/SubmitButton"
import { useState, useEffect } from 'preact/hooks'
import { topCategories } from "../config"

// ask somebody tomorrow or maybe tonight. Is there something I don't know about the way this component is rendering? Is there a chance it could be something other than that. 
export default function Autocomplete() {
    const [ mobileFiltersExist, setMobileFiltersExist ] = useState(false)
    const { products, keywords } = useResponse()
    const { format } = useCurrencyFormatting()

    // console.log("called")
    // console.log("called")
    // console.log("called")
    // if (document.querySelectorAll(".mobile-filters").length > 0) { 
    //     console.log('filters exist')
    //     setMobileFiltersExist(true)
    // } else {
    //     console.log('they dont exist')
    // }

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    // useEffect(() => {
        // console.log("called")
        // console.log("called")
        // console.log("called")
        // if (document.querySelectorAll(".mobile-filters").length > 0) { 
        //     console.log('filters exist')
        //     setMobileFiltersExist(true)
        // } else {
        //     console.log('they dont exist')
        // }
    // })

    // let isMobile = window.innerWidth < 768;
    // const searchInputs = document.querySelectorAll(".predictive-search input");
    // searchInputs.forEach(searchInput => {
    //     searchInput.addEventListener('keydown', (event) => {
    //         if (event.keyCode === 13) {
    //             if (isMobile) {
    //                 activateSearchPage()
    //             }
    //         }
    //     });
    // })


    // every time the autcomplete is opened
    // check if filters exist
    // if they do, add extra space
    // useEffect(() => {
    //     // reduces autocomplete height to make the submit button visible in cases where the filter exists and is overlapping it
    //     const makeSubmitButtonVisible = () => {
    //         const nsAutocompletes = document.querySelectorAll(".ns-autocomplete");
    //         let mobileAutocomplete;
    //         if (nsAutocompletes.length == 3) {
    //             mobileAutocomplete = nsAutocompletes[2]
    //         }
    //         mobileAutocomplete.style.maxHeight = '70vh';
    //     }

    //     if (document.querySelectorAll(".mobile-filters").length > 0) {
    //         makeSubmitButtonVisible();
    //     }
    // }, [])
    // Do I leave the dependency array open, closed, or some variable?
    // I'd assume open is fine

    // useEffect(() => {
    // })

    useEffect(() => {
        const handleKeyDown = (e) => {
            let isMobile = window.innerWidth < 768;
            if (event.keyCode === 13) {
                if (isMobile) {
                    activateSearchPage()
                }
            }            
        }

        const searchInputs = document.querySelectorAll(".predictive-search input");
        searchInputs.forEach(searchInput => {
            searchInput.addEventListener('keydown', handleKeyDown);
        })

        return (() => {
            const searchInputs = document.querySelectorAll(".predictive-search input");
            searchInputs.forEach(searchInput => {
                searchInput.removeEventListener('keydown', handleKeyDown);
            })  
        }) 
    }, [])

    // let mobileFiltersExist = false;
    // // useEffect(() => {
    // console.log('document.querySelectorAll(".mobile-filters")', document.querySelectorAll(".mobile-filters"));
    // setTimeout(() => {
    //     console.log('document.querySelectorAll(".mobile-filters") 500', document.querySelectorAll(".mobile-filters"));
    // }, 500);
    // if (document.querySelectorAll(".mobile-filters").length > 0) { 
    //     console.log('filters exist')
    //     mobileFiltersExist = true;
    // } else {
    //     console.log('they dont exist')
    // }
    // // })
    // console.log('mobileFiltersExist', mobileFiltersExist);

    // useState

    return (
        <div
            class="container ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
            data-nosto-element="autocomplete"
            // style={{maxHeight: "70vh"}}
            style={mobileFiltersExist ? {maxHeight: `70vh`} : {maxHeight: `75vh`}}
            // style={document.querySelectorAll(".mobile-filters")?.length > 0 ? {maxHeight: `70vh`} : {maxHeight: `75vh`}}
        >
            <div class="ns-w-100 ns-mt-sm-auto predictive-search-results">
                {keywords?.hits?.length > 0 && (
                    <div class="predictive-search-suggestion">
                        <span class="predictive-search--label heading-font">Suggestions</span>
                        <div
                            class={`overflow-hidden ns-autocomplete-keywords ns-d-flex ns-flex-row ns-col-12 predictive-suggestion-list`}
                        >
                            <div class="">
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                            {!products?.hits?.length && <SubmitButton text="See all search results" />}
                        </div>
                    </div>
                )}
                {topCategories && (
                    <div class="predictive-search-suggestion">
                        <span class="predictive-search--label heading-font">Top Categories</span>
                        <div
                            class={`overflow-hidden ns-autocomplete-keywords ns-d-flex ns-flex-row ns-col-12 predictive-suggestion-list`}
                        >
                            <div class="">
                            {(window.nostoTopCategories || topCategories).map(category => {
                                if (window.innerWidth < 768) {
                                    if (category.name != "Men's Hoodies & Sweatshirts" && category.name != "Women's Hoodies & Sweatshirts") {
                                        return (
                                            <div class="ns-autocomplete-element ns-clickable ns-py-2 ns-px-4 ns-font-4" data-nosto-query="serve">
                                                <span class='ns-inline-flex'
                                                    onClick={() => {window.location.href = category.url}}
                                                >
                                                    <span class="suggestion-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                            <path d="M5.38324 0C2.41854 0 0 2.41817 0 5.38311C0 8.34809 2.41822 10.7662 5.38324 10.7662C6.61547 10.7662 7.75187 10.3494 8.66087 9.64847L10.8089 11.7965C11.0803 12.0678 11.5254 12.0678 11.7965 11.7965C12.0678 11.5251 12.0678 11.0856 11.7965 10.8143L9.64283 8.66627C10.3453 7.75691 10.7661 6.61685 10.7661 5.38311C10.7661 2.41848 8.34827 0 5.38324 0ZM5.38324 1.38912C7.59707 1.38912 9.37703 3.16902 9.37703 5.3828C9.37703 7.59659 7.59707 9.37649 5.38324 9.37649C3.16941 9.37649 1.38947 7.59659 1.38947 5.3828C1.38947 3.16902 3.16941 1.38912 5.38324 1.38912Z" fill="#5F5B5B"></path>
                                                        </svg>
                                                    </span>
                                                    <div class="keyword">{category.name}</div>
                                                </span>
                                            </div>
                                        )                                        
                                    }
                                } else {
                                    return (
                                        <div class="ns-autocomplete-element ns-clickable ns-py-2 ns-px-4 ns-font-4" data-nosto-query="serve">
                                            <span class='ns-inline-flex'
                                                onClick={() => {window.location.href = category.url}}
                                            >
                                                <span class="suggestion-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                        <path d="M5.38324 0C2.41854 0 0 2.41817 0 5.38311C0 8.34809 2.41822 10.7662 5.38324 10.7662C6.61547 10.7662 7.75187 10.3494 8.66087 9.64847L10.8089 11.7965C11.0803 12.0678 11.5254 12.0678 11.7965 11.7965C12.0678 11.5251 12.0678 11.0856 11.7965 10.8143L9.64283 8.66627C10.3453 7.75691 10.7661 6.61685 10.7661 5.38311C10.7661 2.41848 8.34827 0 5.38324 0ZM5.38324 1.38912C7.59707 1.38912 9.37703 3.16902 9.37703 5.3828C9.37703 7.59659 7.59707 9.37649 5.38324 9.37649C3.16941 9.37649 1.38947 7.59659 1.38947 5.3828C1.38947 3.16902 3.16941 1.38912 5.38324 1.38912Z" fill="#5F5B5B"></path>
                                                    </svg>
                                                </span>
                                                <div class="keyword">{category.name}</div>
                                            </span>
                                        </div>
                                    )
                                }
                            })}
                            </div>
                        </div>
                    </div>
                )}
                <div class="ns-d-flex ns-flex-column ns-flex-sm-row">
                    {products?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                            <span class="predictive-search--label heading-font">Products</span>
                            {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                                Products
                            </div> */}
                            {/* <div class="ns-d-flex ns-flex-column"> */}
                            <div class="tranding-product-list">
                                {products?.hits?.map(hit => {
                                    return (
                                        <AutocompleteElement hit={hit}>
                                            <div
                                                data-url={hit.url}
                                                class="search-product-card ns-clickable"
                                                data-nosto-element="product"
                                            >
                                                <img
                                                    class="search-product-img"
                                                    src={imageResizer(hit.imageUrl, "60") ?? productImagePlaceholder}
                                                    alt={hit.name}
                                                    width="60"
                                                    height="40"
                                                />
                                                <div class="search-product-info">
                                                    <div class="ns-mb-2 ns-font-4 ns-clipped ns-text-one-line">
                                                        {/* {hit.name.toString().split(" - ")[0]} */}
                                                        {hit.name}
                                                    </div>
                                                    <div class="product-price">
                                                        <span class="price-item actual-price">{format(hit.price)}</span>
                                                        {hit.listPrice && hit.listPrice > hit.price && (
                                                            <span class="ns-color-black ns-font-4 ns-text-striked ns-ml-2">
                                                                {format(hit.listPrice)}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </AutocompleteElement>
                                    )
                                })}
                            </div>
                            <SubmitButton 
                                className="search_all_link" 
                                text="See All Results" 
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword"
            onClick={() => {
                console.log('autocomplete element clicked')
                activateSearchPage()
            }}
        >
            <span class="suggestion-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M5.38324 0C2.41854 0 0 2.41817 0 5.38311C0 8.34809 2.41822 10.7662 5.38324 10.7662C6.61547 10.7662 7.75187 10.3494 8.66087 9.64847L10.8089 11.7965C11.0803 12.0678 11.5254 12.0678 11.7965 11.7965C12.0678 11.5251 12.0678 11.0856 11.7965 10.8143L9.64283 8.66627C10.3453 7.75691 10.7661 6.61685 10.7661 5.38311C10.7661 2.41848 8.34827 0 5.38324 0ZM5.38324 1.38912C7.59707 1.38912 9.37703 3.16902 9.37703 5.3828C9.37703 7.59659 7.59707 9.37649 5.38324 9.37649C3.16941 9.37649 1.38947 7.59659 1.38947 5.3828C1.38947 3.16902 3.16941 1.38912 5.38324 1.38912Z" fill="#5F5B5B"></path>
                </svg>
            </span>
            {hit?._highlight?.keyword ? (
                <span class="keyword"
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement 
            hit={hit} 
            filter={filter} 
            class="ns-clickable ns-py-2 ns-px-4 ns-font-4"
        >
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span 
            class="ns-clickable"
        >
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
